import React from 'react';
import PaymentMethodHeader from './PaymentMethodHeader';
import ApplePayButton from './ApplePayButton';
import CreditCardButton from './CreditCardButton';
import CreditCardForm from './CreditCardForm';

const PaymentDetailsSection = ({
  selectedPlan,
  canMakePayment,
  paymentRequest,
  showCardDetails,
  onShowCardDetails,
  cardName,
  onCardNameChange,
  getCurrencySymbol,
  stripeEnabled,
}) => {
  const isLifetime = selectedPlan.type === 'Lifetime';
  
  
  const buttonText = isLifetime 
    ? `Pay with credit card ${getCurrencySymbol()}${selectedPlan.price}` 
    : `Complete subscription for ${getCurrencySymbol()}${selectedPlan.price}`;

  return (
    <div className="bg-primary600 py-4 px-3 mt-6 rounded-sm">
      <PaymentMethodHeader />

      <div>
        {/* Show Apple Pay only for Lifetime plans */}
        {isLifetime && canMakePayment && paymentRequest && (
          <ApplePayButton paymentRequest={paymentRequest} />
        )}

        {!showCardDetails ? (
          <CreditCardButton
            price={selectedPlan.price}
            onClick={onShowCardDetails}
            buttonText={buttonText}
            getCurrencySymbol={getCurrencySymbol}
          />
        ) : (
          <CreditCardForm
            cardName={cardName}
            onCardNameChange={onCardNameChange}
            getCurrencySymbol={getCurrencySymbol}
            price={selectedPlan.price}
            stripeEnabled={stripeEnabled}
            isLifetime={isLifetime}
          />
        )}
      </div>
    </div>
  );
};

export default PaymentDetailsSection;